// extracted by mini-css-extract-plugin
module.exports = {"banner-content":"style_banner-content__3I0xe","left":"style_left__3OusK","right":"style_right__1SwbB"};